/**
 * Whether this counter is running on test data.
 *
 * It is a setting of the business, kept by the server (Settings, "Test mode at the counters"). The till never sends a
 * data mode and cannot choose one: the edge decides it for every request and reports it in `/pos/context`, under the
 * registry key below, so the strip across the top follows the server and nothing kept in the browser.
 */
export const COUNTER_TEST_MODE_KEY = "data.test_mode.counter";

export function counterTestModeOn(settings: Readonly<Record<string, unknown>> | undefined): boolean {
  return settings?.[COUNTER_TEST_MODE_KEY] === true;
}
